export default "__VITE_ASSET__CL1rmeut__"